import { Component, AfterViewInit } from '@angular/core'
import {ControlWidget} from 'ngx-schema-form'

@Component({
  selector: 'custom-string',
  template: `<div class="course-poll-block">
  <div class="field-title">
      {{ schema.title }}
  </div>
  <div *ngIf="schema.description" class="field-description">
      {{ schema.description }}
  </div>
  <input [name]="name"
  [attr.type]="!this.schema.widget.id || this.schema.widget.id === 'string' ? 'text' : this.schema.widget.id"
  placeholder="Краткий ответ" [formControl]="control" [attr.required]="schema.required || null" >
</div>`
})
export class StringWidget extends ControlWidget {
}